module.exports = __webpack_public_path__ + "static/cellphoneHome2-a494abdac42a6bc006524d72ca210dd7.png";